import { useQuery } from '@tanstack/react-query';
import { getQueueAlerts, type GetQueueAlertsParams } from 'services/api/getQueueAlerts';
import { isQueueAlertOpen, type QueueAlert } from 'types/queueAlert.type';
import { queryKeys } from '../queryKeys';

const EMPTY_ALERTS: QueueAlert[] = [];

/**
 * Open queue health alerts. Polled on the same 30s cadence the evaluator runs on, so a
 * resolved alert clears from the UI within one cycle without a manual refresh.
 */
export const useGetQueueAlerts = (params: GetQueueAlertsParams = { active: true }, isEnabled = true) => {
    const { data, isLoading, isFetching, ...rest } = useQuery({
        queryKey: queryKeys.queueAlerts(params),
        queryFn: () => getQueueAlerts(params),
        enabled: isEnabled,
        refetchInterval: isEnabled ? 30_000 : false,
        retry: false,
    });

    return {
        // Filtered here rather than at each surface: active=true is a backend default, not a
        // guarantee, and a resolved alert must not reach any surface.
        queueAlerts: data?.alerts.filter(isQueueAlertOpen) ?? EMPTY_ALERTS,
        isQueueAlertsLoading: isLoading,
        isQueueAlertsFetching: isFetching,
        ...rest,
    };
};
